import React, { useContext } from 'react'
import { AuthContext } from '../../contexts/AuthContext'
import { Loading } from './loading'

export const SignInRedirect = () => {
  const { signinRedirect } = useContext(AuthContext)
  signinRedirect()
  return <Loading />
}
